import { TlfContextProps } from "./interface";

/**
 * Closes the active modal and clears any request-status error state.
 *
 * @param state - Current TLF context state.
 * @returns Updated state with the modal closed.
 */
export const tlf_closeModalWindow = (state: TlfContextProps): TlfContextProps => {
  const newState = { ...state };

  newState.showModalWindow = "";
  newState.requestStatus = { requesting: false, error: false };

  return newState;
};
